import { render, staticRenderFns } from "./DocumentMenu.vue?vue&type=template&id=561b37c7&scoped=true"
import script from "./DocumentMenu.vue?vue&type=script&lang=js"
export * from "./DocumentMenu.vue?vue&type=script&lang=js"
import style0 from "./DocumentMenu.vue?vue&type=style&index=0&id=561b37c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561b37c7",
  null
  
)

export default component.exports